// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2GxF3","log":"ModalInventoryLogs_log__1BK2c","date":"ModalInventoryLogs_date__1F9zw","userName":"ModalInventoryLogs_userName__S0dVY"};